import { Alert, AlertTitle, Button } from '@mui/material';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import "../shared/modern-ui.css";
// import { useUserAuth } from '../../Context/userAuthContext';

const CompanyProfile = () => {
  const [company, setCompany] = useState({});
  const [userDetailsIsFilled, setuserDetailsIsFilled] = useState(false);
  // const [openDialog, setOpenDialog] = useState(false); // Dialog açma durumu Silme islemi
  // const [loading, setLoading] = useState(false); // Silme işlemi sırasında yükleniyor durumu
  // const { logout } = useUserAuth();
  // const loginType = "company"

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get("https://kariyer.biyomed.net/api/companies/getOneDetails", {
          withCredentials: true, // Cookie gönderimi için
        });
        const res = await axios.get("https://kariyer.biyomed.net/api/companies/getOne", {
          withCredentials: true, // Cookie gönderimi için
        });
        setuserDetailsIsFilled(true)
        setCompany({ ...res.data.company, ...response.data.company })
      } catch (error) {
        console.error("Error fetching user:", error);
        setuserDetailsIsFilled(false)
      }
    };

    fetchUser();
  }, []);

  const handleDownload = (pdfData, fileName) => {
    if (pdfData && pdfData.startsWith('data:application/pdf;base64,')) {
      const base64Data = pdfData.split('base64,')[1];  // Base64 verisini ayıklama

      const pdfBlob = new Blob([new Uint8Array(atob(base64Data).split("").map(c => c.charCodeAt(0)))], { type: 'application/pdf' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(pdfBlob);

      link.href = url;
      link.download = fileName; // Kullanıcının indireceği dosya adı
      link.click();

      // URL'yi serbest bırak
      URL.revokeObjectURL(url);
    } else {
      console.error("Geçersiz Base64 verisi:", pdfData);
      alert("Geçersiz PDF verisi.");
    }
  };

  // const handleDeleteUser = async () => {
  //   try {
  //     setLoading(true); // Silme işlemi başlatılıyor   
  //     await axios.delete("https://kariyer.biyomed.net/api/company/deleteCompany", {
  //       withCredentials: true, // Cookie gönderimi için
  //     });
  //     alert("Hesabınız başarıyla silindi.");
  //     await logout(loginType);
  //     window.location.href = "/"; // Ana sayfaya yönlendirme
  //   } catch (error) {
  //     console.error("Hesap silme işlemi başarısız:", error);
  //     alert("Hesap silme işlemi başarısız. Lütfen tekrar deneyin.");
  //   } finally {
  //     setLoading(false); // Yükleniyor durumu bitiyor
  //     await logout(loginType);
  //     // setOpenDialog(false); // Dialog kapanıyor
  //   }
  // };

  // const handleOpenDialog = () => {
  //   setOpenDialog(true); // Dialog açılıyor
  // };

  // const handleCloseDialog = () => {
  //   setOpenDialog(false); // Dialog kapanıyor
  // };

  // Link basinda https yoksa tamamlar
  const withProtocol = (url) =>
    url && !url.startsWith("http") ? `https://${url}` : url;

  // Bilgi satiri: deger yoksa "Belirtilmemis" gosterir
  const InfoItem = ({ label, value, wide = false }) => (
    <div className={`bm-info-item${wide ? " bm-info-item--wide" : ""}`}>
      <span className="bm-info-label">{label}</span>
      <div className={`bm-info-value${value ? "" : " bm-info-value--empty"}`}>
        {value || "Belirtilmemiş"}
      </div>
    </div>
  );

  return (
    <div className="bm-page">
      <div className="bm-container">
        <div className="bm-page-head">
          <h1 className="bm-page-title">Firma Profili</h1>
          <p className="bm-page-sub">
            Kurum bilgilerinizi görüntüleyip güncelleyebilirsiniz.
          </p>
        </div>

        <div className="bm-profile-grid">
          {/* Sol kolon: logo, site linki, eylemler */}
          <div>
            <div className="bm-card">
              <div className="bm-profile-hero">
                <div className="bm-profile-cover" />
                <img
                  className="bm-avatar"
                  src={company.profile_image ? company.profile_image : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"}
                  alt="profile_img"
                />
                <h2 className="bm-profile-name">
                  {company.company_name || "Firma"}
                </h2>
                {company.email ? (
                  <p className="bm-profile-meta">{company.email}</p>
                ) : null}

                {company.profile_link ? (
                  <ul className="bm-social">
                    <li>
                      <a
                        href={withProtocol(company.profile_link)}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Web sitesi"
                      >
                        <i className="fa fa-globe" />
                      </a>
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="bm-card-body" style={{ paddingTop: 0 }}>
                <ul className="bm-action-list">
                  <li>
                    <a href={userDetailsIsFilled ? "/update-company-details" : "/company-details"}>
                      <i className="fa fa-pencil" />
                      {userDetailsIsFilled ? "Detay Bilgilerini Düzenle" : "Profili Oluştur"}
                    </a>
                  </li>
                  {/* <li>
                    <a onClick={handleOpenDialog}>
                      Hesabı Sil
                    </a>
                  </li> */}
                  <li>
                    <a href='/update-company-info'>
                      <i className="fa fa-id-card-o" />
                      Kayıt Bilgilerini Düzenle
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sag kolon: firma bilgileri */}
          <div>
            {userDetailsIsFilled ? (
              <>
                <div className="bm-card">
                  <div className="bm-card-head">
                    <span className="bm-card-badge">
                      <i className="fa fa-building-o" />
                    </span>
                    <h3>Firma / Sağlık Kuruluşu Bilgileri</h3>
                  </div>
                  <div className="bm-card-body">
                    <div className="bm-info-list">
                      <InfoItem label="Firma / Sağlık Kuruluşu Adı" value={company?.company_name} />
                      <InfoItem label="E-posta" value={company?.email} />
                      <InfoItem label="Telefon" value={company?.phone} />
                      <div className="bm-info-item">
                        <span className="bm-info-label">Web Sayfası</span>
                        <div className={`bm-info-value${company?.website ? "" : " bm-info-value--empty"}`}>
                          {company?.website ? (
                            <a
                              href={withProtocol(company.website)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {company.website}
                            </a>
                          ) : (
                            "Belirtilmemiş"
                          )}
                        </div>
                      </div>
                      <InfoItem label="İl" value={company?.city} />
                      <InfoItem label="Vergi No / ÜTS Firma No" value={company?.company_number} />
                      <InfoItem label="Adres" value={company?.company_address} wide />
                    </div>
                  </div>
                </div>

                <div className="bm-card">
                  <div className="bm-card-head">
                    <span className="bm-card-badge">
                      <i className="fa fa-file-text-o" />
                    </span>
                    <h3>Belgeler</h3>
                  </div>
                  <div className="bm-card-body">
                    <div className="bm-info-list">
                      <div className="bm-info-item bm-info-item--wide">
                        <span className="bm-info-label">Destekleyici Doküman</span>
                        <div className="bm-info-value">
                          {company.support_document ? (
                            <Button
                              variant="outlined"
                              size="small"
                              color="primary"
                              onClick={() => handleDownload(company.support_document, `${company.company_name}_support_document.pdf`)}
                              startIcon={<FaFilePdf />}
                              sx={{ textTransform: "none", borderRadius: "10px" }}
                            >
                              Belgeyi indir
                            </Button>
                          ) : (
                            <span className="bm-info-value--empty">Mevcut değil</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="bm-card">
                <div className="bm-card-body">
                  <Alert severity="success" sx={{ borderRadius: "12px" }}>
                    <AlertTitle>Kayıt Onaylandı</AlertTitle>
                    Kaydınız başarıyla onaylanmıştır. Lütfen{" "}
                    <strong>Profili Oluştur</strong> butonuna basarak detay bilgilerinizi
                    girerek kaydınızı tamamlayınız.
                  </Alert>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Hesabı Silme Onayı</DialogTitle>
        <DialogContent>
          <p>Hesabınızı silerseniz oluşturduğunuz ilanlar ve bilgileriniz tamamen silinecektir. Onaylıyor musunuz?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Vazgeç
          </Button>
          <Button 
            onClick={handleDeleteUser} 
            color="error" 
            disabled={loading}
          >
            {loading ? "Siliniyor..." : "Evet, Sil!"}
          </Button>
        </DialogActions>
      </Dialog> */}
    </div>
  );
};

export default CompanyProfile;
